import { FC, useMemo } from 'react';

import { useFormikContext } from 'formik';
import { Button, Tooltip } from 'ui/components/common';
import { Input } from 'ui/components/form';
import { SIZE } from 'utils/constants';

import { CHANGE_PASSWORD_FORM } from './schema';

interface PROPS {
  disabled?: boolean;
}

const ChangePasswordForm: FC<PROPS> = ({ disabled }) => {
  const {
    values,
    touched,
    errors,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
  } = useFormikContext<CHANGE_PASSWORD_FORM>();

  const passed = useMemo(() => {
    if (
      !isSubmitting &&
      !Object.entries(errors).length &&
      values.password &&
      values.passwordConfirmation
    )
      return true;

    return false;
  }, [errors, isSubmitting, values.password, values.passwordConfirmation]);

  return (
    <form onSubmit={handleSubmit}>
      <div className="mb-3 space-y-3">
        <Tooltip
          title="Password must contain at least 8 characters including a number and a letter."
          theme="light"
          placement="right"
          className="w-full"
        >
          <Input
            className="max-w-[428px] w-full"
            type="password"
            name="password"
            size={SIZE.Large}
            textType={
              errors.password && touched.password ? 'danger' : 'default'
            }
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.password}
            placeholder="Enter new password"
            subText={errors.password && touched.password ? errors.password : ''}
            disabled={isSubmitting}
          />
        </Tooltip>
        <Input
          className="w-full"
          type="password"
          name="passwordConfirmation"
          size={SIZE.Large}
          textType={
            errors.passwordConfirmation && touched.passwordConfirmation
              ? 'danger'
              : 'default'
          }
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.passwordConfirmation}
          placeholder="Re-enter password"
          subText={
            errors.passwordConfirmation && touched.passwordConfirmation
              ? errors.passwordConfirmation
              : ''
          }
          disabled={isSubmitting}
        />
      </div>
      <Button
        label="SAVE"
        type="submit"
        disabled={!passed || disabled}
        className="w-full font-semibold mb-[15px]"
        size="lg"
      />
    </form>
  );
};

export default ChangePasswordForm;
